import * as React from "react";
import {Component } from "react";

import {observer} from "mobx-react";
import {AppState} from "../../components/app/app-mobx";

import {Button, Grid, Item, Loader, Popup, /* Table*/} from "semantic-ui-react";
import {MapViewerConfiguration} from "../../config/map-viewer-configuration";

import {AppConfiguration} from "../../core/config/app-configuration";

import {MapState} from "../../core/map-state";

import {ContractorItem} from "./contractor-item";
import {NavigationConfiguration} from "../../config/navigation-configuration";
import {Auftragsverwaltung} from "../../stores/auftragsverwaltung-mobx";
import {Contractor} from "../../models/contractor";
import {Icon} from "../../core/components/icon/icon";
import {ContractorSearch} from "./contractor-search";


export interface ContractorListProps {
    view: __esri.MapView | __esri.SceneView | undefined;
    auftragsverwaltung: Auftragsverwaltung;
    appStore: AppState;
    mapStore: MapState;
    mapViewerConfig: MapViewerConfiguration;
    appConfig: AppConfiguration;
}

@observer
export class ContractorList extends Component<ContractorListProps, any> {

    constructor(props: ContractorListProps) {
        super(props);
        this.state = {
            highlightedItemId: null,
            graphic: null
        };
    }

    componentDidMount(): void {
        const {auftragsverwaltung, appStore} = this.props;

        auftragsverwaltung.setShowMap(false);

        const {topic} = appStore;

        const newRoute = topic.routes[0];
        const breadcrumbs = new NavigationConfiguration();
        breadcrumbs.items = [
            { href: newRoute, title: topic.label }
        ];

        appStore.setPageTitle(topic.label);
        appStore.setTopContent(null);
        appStore.setBottomContent(null);
        appStore.setBreadcrumbs(breadcrumbs);
    }

    componentWillUnmount(): void {}

    showContractor(contractor: Contractor): void {
        const {auftragsverwaltung, appStore} = this.props;

        if (!contractor) {
            return;
        }

        appStore.setObjectId(contractor.id.toString());
        auftragsverwaltung.ContractorStore.setSelectedItem(contractor);
        // // request full details --> will select project when loaded
        // auftragsverwaltung.ContractorStore.loadItem(contractor.id);
    }

    handleNewContractor(): void {
        const {auftragsverwaltung, appStore} = this.props;
        // do not show map when editing
        auftragsverwaltung.setShowMap(false);

        const user = appStore.esriCredential?.userId || "";
        auftragsverwaltung.ContractorStore.newItem(user).then((newContractor) => {
            if (newContractor) {
                // do not show map when editing
                auftragsverwaltung.setShowMap(false);
                appStore.setObjectId(newContractor.id.toString());
                auftragsverwaltung.setEditing(true, "contractor");
            }
        });
    }

    render(): React.ReactElement | null {
        const { auftragsverwaltung} = this.props;
        const isLoading = auftragsverwaltung.ContractorStore.isLoading;
        const visibleItems = auftragsverwaltung.ContractorStore.visibleItems;

        if(!visibleItems ) {
            return null;
        }

        const newContractorButton = (
            <Popup content="Neuer Auftragnehmer"
                trigger={
                    <Button className={"new-contractor"} circular
                        onClick={(e: React.MouseEvent) => {
                            e.preventDefault();
                            // Wenn blur direkt via e.target aufgerufen wird, reklamiert Webstorm:
                            // TS2339: Property 'blur' does not exist on type 'EventTarget'.
                            const target = e.target as HTMLElement;
                            target.blur();

                            this.handleNewContractor();
                        }}>
                        <Icon name={"navigate_plus"} />
                    </Button>
                } />
        );

        let content: React.ReactElement | undefined;
        if (visibleItems.length === 0) {
            content = (
                <div>
                    <Item size="mini">
                        <Item.Content className="no-results">
                        Keine Auftragnehmer gefunden.
                        </Item.Content>
                    </Item>
                </div>
            );
        }
        else {
            content = (
                <Item.Group divided link>
                    {visibleItems.map((contractor: Contractor) => (
                        <ContractorItem
                            key={contractor.id}
                            contractor={contractor}
                            handleShowContractor={(c: Contractor) => {
                                this.showContractor(c);
                            }}
                        />
                    ))}
                </Item.Group>
            );
        }

        return (<>
            <Grid>
                <Grid.Column width={2}>
                    {newContractorButton}
                </Grid.Column>
                <Grid.Column width={8}>
                    <ContractorSearch auftragsverwaltung={auftragsverwaltung} />
                </Grid.Column>
                <Grid.Column width={1}>
                    {isLoading && <Loader active inline />}
                </Grid.Column>
            </Grid>
            {content}
        </>);
    }
}
